<template>
  <v-btn loading block v-if="loading">Uploading...</v-btn>
  <div class="custom-field" v-else>
    <custom-field-label :field="{ required, description, label }" />
    <v-file-input
      hide-details="auto"
      variant="outlined"
      color="primary"
      ref="fileInput"
      :disabled="loading"
      :multiple="multiple"
      :placeholder="placeholder"
      v-model="selectedFiles"
      @change="onFileChanged"
      @click:clear="notifyClearFile"
      :error-messages="errorMessages"
      :required="required"></v-file-input>
  </div>
</template>

<script>
import { castArray } from 'lodash';

import cometApiService from '@/services/cometApiService';
import { uploadDocumentBatch } from './documentUpload';

export default {
  mixins: [],
  components: {},
  props: {
    appointmentIdentifier: {
      type: String,
      required: false
    },
    warehouseId: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false,
      default: 'File uploader'
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    description: {
      type: String,
      required: false
    },
    multiple: {
      type: Boolean,
      required: false
    }
  },
  setup() {
    const { uploadDocuments } = cometApiService();
    return { uploadDocuments };
  },
  data() {
    return {
      renderKey: 0,
      mounted: false,
      selectedFiles: [],
      isSelectingFile: false,
      fileUrls: [],
      fileKeys: [],
      tempFileBase64: '',
      tempFileSize: 0,
      errorMessages: [],
      loading: false
    };
  },
  methods: {
    notifyClearFile() {
      this.fileUrls = [];
      this.fileKeys = [];
      this.errorMessages = [];

      this.$emit('cleared');
    },
    async uploadFile() {
      const selectedFiles = castArray(this.selectedFiles).filter(Boolean);

      if (selectedFiles.length === 0) {
        // nothing to upload
        return;
      }

      this.isSelectingFile = true;
      this.loading = true;

      const result = await uploadDocumentBatch({
        upload: this.uploadDocuments,
        warehouseId: this.warehouseId,
        appointmentIdentifier: this.appointmentIdentifier,
        files: selectedFiles,
        existingKeys: this.fileKeys
      });

      this.clearDataProps();

      if (result.status === 'rejected') {
        // Nothing is emitted on failure: the selection stays in the input so the driver can
        // retry, instead of the form moving on with an incomplete set of keys.
        this.errorMessages = [result.error];
        return;
      }

      this.errorMessages = [];
      this.fileUrls.push(...result.documents.map(document => document.url));
      this.fileKeys.push(...result.documents.map(document => document.key));

      this.$emit('uploaded', this.multiple ? this.fileKeys : this.fileKeys[0]);
    },

    async onFileChanged() {
      await this.uploadFile();
    },
    clearDataProps() {
      this.isSelectingFile = false;
      this.tempFileBase64 = null;
      this.tempFileSize = 0;
      this.loading = false;
    }
  },
  mounted() {
    this.mounted = true;
  }
};
</script>
